import { useContext, useEffect, useState } from "react";
import { Container, Nav, Navbar, NavDropdown } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import esurveylogonew from "../../assets/images/logo.png";
import { UserContext } from "../../routes/routes";
import { RoleTypeCode } from "../../utils/Constant";
import "./Header.scss";
function Header() {
  const navigate = useNavigate();
  const handleLogout = () => {

    const keysToKeep = ['email', 'rememberMe','PageRecordLimit'];
    const valuesToKeep = keysToKeep.reduce((acc: any, key) => {
      const value = localStorage.getItem(key);
      if (value !== null) {
        acc[key] = value;
      }
      return acc;
    }, {});
    localStorage.clear();
    // Restore the preserved values
    Object.keys(valuesToKeep).forEach((key) => {
      localStorage.setItem(key, valuesToKeep[key]);
    });
    // localStorage.clear();
     window.location.href = "/login";
    // navigate("/login");
  };
  const { appContextdata } = useContext<any>(UserContext);
  const [organization, setOrganization] = useState("");
  const [userName, setUserName] = useState("");
  const [userNameImage, setUserNameImage] = useState<string>("");

  useEffect(() => {
    setOrganization(appContextdata?.OrganizationName);
    setUserName(appContextdata?.User?.split(' ')[0]);
    setUserNameImage(
      appContextdata?.User
        ? `${appContextdata?.User[0]}${appContextdata?.User.split(' ')[1]?.[0] || ''}`.toUpperCase()
        : ''
    );    
  }, [appContextdata?.Role]);

  return (
    <div className="nav">
      <Navbar expand="lg" className="navbar bg-white w-100">
        <Container fluid>
          <Navbar.Brand
            href="#"
            className="d-flex align-items-center gap-lg-2 gap-1"
          >
            <img src={esurveylogonew} className="esurveylogo" alt="logo" />
            <span className="org-name">{organization}</span>
          </Navbar.Brand>
          {/* <Navbar.Toggle aria-controls="navbarScroll" /> */}
          <Navbar>
            <Nav className="ms-auto" navbarScroll>
              <div className="user-detail d-flex align-items-center ">
              <span className={`${userNameImage ? `userName-${userNameImage[0]}` : ''}`}>{userNameImage}</span>
                <NavDropdown
                  title={userName}
                  id="navbarScrollingDropdown"
                  align="end"
                  className=""
                >
                  <NavDropdown.Item
                    href="#"
                    onClick={() => navigate("/changePassword")}
                  >
                    Change Password
                  </NavDropdown.Item>
                  {(appContextdata?.Role === RoleTypeCode?.Administrator || appContextdata?.Role === RoleTypeCode?.SuperAdmin) && (
                  <NavDropdown.Item
                    href="#"
                    onClick={() => navigate("/subscription-plan")}
                  >
                    Subscription Plan
                  </NavDropdown.Item>
                  )}
                  <NavDropdown.Item href="#" onClick={handleLogout}>
                    Logout
                  </NavDropdown.Item>
                </NavDropdown>
              </div>
            </Nav>
          </Navbar>
        </Container>
      </Navbar>
    </div>
  );
}

export default Header;
